'use strict';

/**
 *  Load modules
 */
import burgerMenu from './modules/burgerMenu';
import mobileMenu from './modules/mobileMenu';
import { handleScroll } from './modules/scrollHandler';
import gateCookies from './modules/gateCookies.js';
import parallax from './modules/parallax.js';
import sessionMap from './modules/sessionMap.js';
import sessionMobileAccordion from './modules/sessionMobileAccordion.js';
import aos from './modules/aos.js';
import shareSocial from './modules/shareSocial.js';
import video from './modules/video.js';

(function($) {
    handleScroll();
})(jQuery);

document.addEventListener("DOMContentLoaded", function () {
    aos();
    shareSocial();
});